import { render, staticRenderFns } from "./EnrollList.vue?vue&type=template&id=284fc31a&scoped=true"
import script from "./EnrollList.vue?vue&type=script&lang=js"
export * from "./EnrollList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284fc31a",
  null
  
)

export default component.exports